module.exports = __webpack_public_path__ + "img/orthotic-athletic.0ce0a79d.png";